import React, { createContext, useState, useContext } from "react";

const ThemeContext = createContext(null);

export function useThemeMode() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeMode must be used within a ThemeProvider (ThemeContext)");
  }
  return context;
}

/**
 * Holds darkMode preference for when light mode is re-enabled.
 * Theme is currently locked to dark in index.js — do not wire a UI toggle yet.
 */
export function ThemeModeProvider({ children }) {
  const [darkMode, setDarkMode] = useState(true);

  const value = {
    darkMode,
    setDarkMode,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeContext;
